<template>
	<div>
	    <h1>Projects</h1>
	    <div class="project-panel">
	    	<div class="mt-3">
				<b-button-group>
					<b-button variant="success" to="/projects/my/offers">My Offers {{counter.my.offers}}</b-button>
					<b-button variant="success" to="/projects/other/offers">Other Offers {{counter.other.offers}}</b-button>
				</b-button-group>
			</div>
			<div class="mt-3">
				<b-button-group>
					<b-button variant="primary" to="/projects/my/active">My Active {{counter.my.active}}</b-button>
					<b-button variant="primary" to="/projects/other/active">Other Active {{counter.other.active}}</b-button>
				</b-button-group>
			</div>
			<div>	
				<b-button-group>
					<b-button variant="info" to="/projects/my/archive">My Archive {{counter.my.archive}}</b-button>
					<b-button variant="info" to="/projects/other/archive">Other Archive {{counter.other.archive}}</b-button>
				</b-button-group>
			</div>
			<div>
				<b-button-group>
					<b-button variant="warning" v-b-modal.new-offer-modal>Create Offer</b-button>
				</b-button-group>
			</div>
	    </div>
	    <b-modal id="new-offer-modal" :title="'New Offer'" okTitleHtml="Create">
			<ProjectCreateEditWidget :mode="'create'"></ProjectCreateEditWidget>
		</b-modal>
	</div>
</template>
<script>
import ProjectCreateEditWidget from './ProjectCreateEditWidget.vue'
export default {
	name: 'DashboardPage',
	components:{
		ProjectCreateEditWidget
	},
	data(){
		return {
			counter:{
				my:{
					offers:0,
					active:0,
					archive:0
				},
				other:{
					offers:0,
					active:0,
					archive:0
				}
			}
		}
	},
	mounted(){
		if(!this.$API.loggedIn){
		    this.$router.push("/login?redirect=" + this.$route.path);
		    return;
		}
		this.$API.title="Dashboard";
		this.updateCounter();
	},
	methods:{
		updateCounter(){
				this.$API.apiGET("/projects/count", true).then((response)=>{
				this.counter=response.counter;
			});
		}
	}
}
</script>
<style type="text/css" scoped>
	.project-panel a{
		margin: 10px;
	}
</style>